<!-- #735: Zeilenbild nach settings-form. Der Rahmen gehoert der host-Klasse der Row,
     die Box traegt daher nur bg-white (kein border-b, sonst zwei Unterkanten). -->
<nx-default-box class="bg-white">
  <ng-template nxTemplate="content">
    <div class="flex flex-row items-center">

      <!-- Typ-Label: kommt fertig uebersetzt vom Server, NIE durch die translate-Pipe -->
      <div class="grow flex flex-col">
        <div>{{ type().label }}</div>
      </div>

      <!-- Kanal-Checkboxen: feste Slots In-App, E-Mail, Push. Ein Kanal, den der Server fuer
           diesen Typ nicht liefert (HIDDEN), laesst seinen Slot LEER, damit die Zeile
           spaltentreu zur Kopfzeile bleibt. Ein nicht editierbarer Kanal erscheint angehakt und
           deaktiviert.
           Der Tooltip haengt am WRAPPER, nicht an der Checkbox: PrimeNG setzt auf
           .p-checkbox-disabled pointer-events: none, an der Checkbox selbst loeste er nie aus. -->
      <div class="min-w-[27rem] flex flex-row items-center justify-end">
        @for (channel of channelSlots(); track $index) {
          <div class="w-32 flex flex-row justify-center">
            @if (channel) {
              <div [pTooltip]="forcedHint(channel) | translate">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="channel.effectiveEnabled"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="locked() || !channel.editable"
                  [ariaLabel]="type().label + ' – ' + (channelLabel(channel.channel) | translate)"
                  (onChange)="onToggle(channel, $event.checked)">
                </p-checkbox>
              </div>
            }
          </div>
        }

        <!-- Test-Send: nur fuer framework_nexato_employee, ausgeblendet statt disabled.
             disabled nur waehrend der laufenden Mutation (kein Rate-Limiting serverseitig). -->
        <div class="w-12 flex flex-row justify-end">
          @if (canSendTest()) {
            <nx-default-button
              (click)="testRequested.emit()"
              [disabled]="sendingTest()"
              [attr.aria-label]="type().label + ' – ' + ('core.user.profile.notifications.sendTest' | translate)"
              [tooltip]="'core.user.profile.notifications.sendTest' | translate"
              [icon]="'icon-send'"
              [style]="'light'">
            </nx-default-button>
          }
        </div>
      </div>
    </div>
  </ng-template>
</nx-default-box>
